import { observer } from 'mobx-react';
import React, { useEffect, useState } from 'react';

import { DataTable } from '../../../../design/dataTable/DataTable';
import { IAdminPageProperties } from '../../IAdminPageProperties';
import { RequirementCategoryAdminDomain } from './store/RequirementCategoryAdminDomain';

export interface IRequirementCategoryAdminTable extends IAdminPageProperties { }

export const RequirementCategoryAdminTable = observer(({ layoutDomain }: IRequirementCategoryAdminTable) => {
  useEffect(() => {
    layoutDomain.ui.pagePadding.setValue(0)
    return () => layoutDomain.ui.pagePadding.setValue(24)
  }, [])
  const [domain] = useState<RequirementCategoryAdminDomain>(new RequirementCategoryAdminDomain(layoutDomain));

  return <DataTable dataTableDomain={domain} tableHeight={window.innerHeight} />;
});
